/**
 * Convert markdown to clean plain text for copying
 * Removes markdown syntax, citation markers, and formatting while preserving content structure
 * Output matches what users see visually (headers, lists, paragraphs)
 */
export function markdownToText(markdown) {
  if (!markdown || typeof markdown !== 'string') return '';
  
  let text = markdown;
  
  // Remove citation markers like [1], [2], [x], etc. (but preserve structure)
  text = text.replace(/\s*\[\d+\]\s*/g, ' ');
  text = text.replace(/\s*\[[xX]\]\s*/g, ' ');
  
  // Process headers - convert to plain text with line breaks
  // # Header -> Header (with blank line after)
  text = text.replace(/^#{1}\s+(.+)$/gm, '$1\n');
  text = text.replace(/^#{2}\s+(.+)$/gm, '$1\n');
  text = text.replace(/^#{3}\s+(.+)$/gm, '$1\n');
  text = text.replace(/^#{4,6}\s+(.+)$/gm, '$1\n');
  
  // Remove bold/italic markers but keep the text
  // Handle nested bold/italic carefully
  text = text.replace(/\*\*([^*]+)\*\*/g, '$1'); // **bold**
  text = text.replace(/\*([^*\n]+)\*/g, '$1'); // *italic* (but not if it's a list marker)
  text = text.replace(/__([^_]+)__/g, '$1'); // __bold__
  text = text.replace(/_([^_\n]+)_/g, '$1'); // _italic_
  
  // Remove links but keep the text [text](url) -> text
  text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
  
  // Remove images ![alt](url)
  text = text.replace(/!\[([^\]]*)\]\([^)]+\)/g, '');
  
  // Remove code blocks ```code``` (replace with just the code content)
  text = text.replace(/```[\w]*\n?([\s\S]*?)```/g, '$1');
  // Remove inline code `code` but keep the text
  text = text.replace(/`([^`]+)`/g, '$1');
  
  // Remove horizontal rules (---, ***)
  text = text.replace(/^[-*]{3,}$/gm, '');
  
  // Remove blockquotes (> text) but keep the text
  text = text.replace(/^>\s+/gm, '');
  
  // Process lists - convert markdown list markers to plain text bullets
  // Unordered lists: -, *, + -> •
  text = text.replace(/^[\s]*[-*+]\s+(.+)$/gm, '• $1');
  // Ordered lists: 1., 2., etc. -> 1., 2., etc. (keep numbers)
  // Already handled by keeping the numbers
  
  // Clean up multiple spaces (but preserve intentional spacing)
  text = text.replace(/[ \t]{2,}/g, ' '); // Multiple spaces/tabs to single space
  
  // Clean up excessive newlines (max 2 consecutive)
  text = text.replace(/\n{3,}/g, '\n\n');
  
  // Remove trailing spaces before newlines
  text = text.replace(/[ \t]+\n/g, '\n');
  
  // Remove leading spaces after newlines (except for list indentation)
  text = text.replace(/\n[ \t]+/g, '\n');
  
  // Final cleanup - ensure consistent spacing
  text = text.replace(/\n\n\n+/g, '\n\n'); // Max 2 newlines
  
  // Trim and return
  return text.trim();
}
